export default __webpack_public_path__ + "static/media/smartRemindersPic.3f3a8706.png";